import { SHORTCUT_CATALOG_PRODUCT_FIELDS } from '@@partner:graphql/shortcuts'
import type {
  Product,
  ProductPrice,
  PriceType,
  ProductStock
} from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface ProductInfoInput {
  id?: GQL_ID
  xid?: string
  name: string
  weight?: number
  min_count?: number
  short_description?: string
  w?: number
  h?: number
  l?: number
  v?: number
  pkg?: string
  ingredients?: string
  nutval?: string
  brand_id?: GQL_ID
  shop_ids: GQL_ID[]
  marketingLabelIds: GQL_ID[]

  stocks: ProductStock[]
  singleStock: number
  useSingleStock: boolean
  price_type: PriceType
  preview_id?: GQL_ID
  galleryImageIds: GQL_ID[]
  markable: boolean
  markCodeType: string

  indexable: boolean

  productProperties?: {
    fats?: string | null
    proteins?: string | null
    calories?: string | null
    carbohydrates?: string | null
    shelfLife?: string | null
    manufacturerName?: string | null
    country?: string | null
  }
}

export interface SaveProduct {
  product: Product
}

export interface SaveProductVariables {
  productInfo: ProductInfoInput
}

export const GQL_MUTATION_SAVE_PRODUCT = gql`
  mutation($productInfo: ProductInfoInput!) {
    product: saveProduct(productInfo: $productInfo) {
      ${SHORTCUT_CATALOG_PRODUCT_FIELDS}
    }
  }
`

export const useSaveProduct = () => {
  return useMutation<SaveProduct, SaveProductVariables>(
    GQL_MUTATION_SAVE_PRODUCT
  )
}
